// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thm-container {
  width: 100%;
  max-width: 1200px;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.comparePolicyScreenTopHeading {
  background-color: #424e71;
  color: #fff;
  padding: 10px 0px;
  text-align: left;
  border: 1px solid #323c5a;
}
.custom-select {
  height: 35px; 
  border-radius: inherit;
}
.compareDetailssection {
  background-color: #fff;
}

.compareDetailssectionleft,
.compareDetailssectionright {
  border: 1px solid #dfdfdf;
  padding-top: 0px;
  padding-bottom: 10px;
}

.compareDetailssection div#myTabContent {
  padding: 10px;
}

.tab-content > .active {
  display: block;
}
.react-form-wizard .wizard-tab-content {
  min-height: 100px;
  padding: 30px 20px 10px;
  text-align: start !important;
}

.logoskybluecolor {
  color: #3ca8e8;
  margin-bottom: 20px;
  position: relative;
}

.mainPolicyHeading {
  position: relative;
  padding: 20px 0px;
}

h3.logoskybluecolor:before {
  content: "";
  position: absolute;
  top: 35px;
  height: 5px;
  width: 55px;
  background-color: #25335b;
}

h3.logoskybluecolor:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 37px;
  height: 1px;
  width: 95%;
  max-width: 255px;
  background-color: #25335b;
}

.mainPolicyHeading h4:before {
  content: "";
  position: absolute;
  top: 48px;
  height: 5px;
  width: 55px;
  background-color: #25335b;
}

.mainPolicyHeading h4:after {
  content: "";
  position: absolute;
  left: 15px;
  top: 50px;
  height: 1px;
  width: 95%;
  max-width: 255px;
  background-color: #25335b;
}

`, "",{"version":3,"sources":["webpack://./src/Sidebar/PoliciesFormFillingPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".thm-container {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  display: block;\r\n}\r\n\r\n.comparePolicyScreenTopHeading {\r\n  background-color: #424e71;\r\n  color: #fff;\r\n  padding: 10px 0px;\r\n  text-align: left;\r\n  border: 1px solid #323c5a;\r\n}\r\n.custom-select {\r\n  height: 35px; \r\n  border-radius: inherit;\r\n}\r\n.compareDetailssection {\r\n  background-color: #fff;\r\n}\r\n\r\n.compareDetailssectionleft,\r\n.compareDetailssectionright {\r\n  border: 1px solid #dfdfdf;\r\n  padding-top: 0px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.compareDetailssection div#myTabContent {\r\n  padding: 10px;\r\n}\r\n\r\n.tab-content > .active {\r\n  display: block;\r\n}\r\n.react-form-wizard .wizard-tab-content {\r\n  min-height: 100px;\r\n  padding: 30px 20px 10px;\r\n  text-align: start !important;\r\n}\r\n\r\n.logoskybluecolor {\r\n  color: #3ca8e8;\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n}\r\n\r\n.mainPolicyHeading {\r\n  position: relative;\r\n  padding: 20px 0px;\r\n}\r\n\r\nh3.logoskybluecolor:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 35px;\r\n  height: 5px;\r\n  width: 55px;\r\n  background-color: #25335b;\r\n}\r\n\r\nh3.logoskybluecolor:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 37px;\r\n  height: 1px;\r\n  width: 95%;\r\n  max-width: 255px;\r\n  background-color: #25335b;\r\n}\r\n\r\n.mainPolicyHeading h4:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 48px;\r\n  height: 5px;\r\n  width: 55px;\r\n  background-color: #25335b;\r\n}\r\n\r\n.mainPolicyHeading h4:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 50px;\r\n  height: 1px;\r\n  width: 95%;\r\n  max-width: 255px;\r\n  background-color: #25335b;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
